module.exports = __webpack_public_path__ + "img/每天只做今日任务_copy2.7af51e82.png";